/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconToiletPaper = createReactComponent("toilet-paper", "IconToiletPaper", [
  ["path", { d: "M6 10m-3 0a3 7 0 1 0 6 0a3 7 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M21 10c0 -3.866 -1.343 -7 -3 -7", key: "svg-1" }],
  ["path", { d: "M6 3h12", key: "svg-2" }],
  ["path", { d: "M21 10v10l-3 -1l-3 2l-3 -3l-3 2v-10", key: "svg-3" }],
  ["path", { d: "M6 10h.01", key: "svg-4" }]
]);

export { IconToiletPaper as default };
//# sourceMappingURL=IconToiletPaper.js.map
